<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      title="기본 정보(도급·용역·위탁사업 현황)"
      :options="[
        { type: 'text', label: '계약명', value: '계약명'},
      ]"
      :typeslabel="{
        com_name: '업체명',
      }"
    />

    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 계약 현황</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">계약금액</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_1 }}</p>
        <ml-input
          :readonly="board.readonly"
          v-else
          v-model="form.inputB_1"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업기간</div>
        <p v-if="isPrint" class="print-input flex-1">
          {{ form.inputB_2 }} ~ {{ form.inputB_3 }}
        </p>
        <div v-else class="flex" style="align-items: center;">
          <date-selector
            :readonly="board.readonly"
            v-model="form.inputB_2"
          />
          <span>&nbsp;~&nbsp;</span>
          <date-selector
            :readonly="board.readonly"
            v-model="form.inputB_3"
          />
        </div>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">안전보건관리비 사용내역</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
        <div v-else class="w-full flex-1 flex gap-4">
          <vs-radio v-model="form.inputB_4" :disabled="board.readonly" vs-value="유">유</vs-radio>
          <vs-radio v-model="form.inputB_4" :disabled="board.readonly" vs-value="무">무</vs-radio>
        </div>
      </div>
      <div v-if="form.inputB_4 === '유'" class="col-span-8"></div>
      <div v-if="form.inputB_4 === '유'" class="col-span-4 flex items-center">
        <div class="label-text mr-4" style="width: 146px;">· 편성금액</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputB_4_1 }}</p>
        <div v-else class="w-full grid" style="'grid-template-rows: 1fr 1fr'">
          <vs-input
            class="w-full"
            :readonly="board.readonly"
            v-model="form.inputB_4_1"
          />
          <p>(개인보호구,안전보건조치 비용 등)</p>
        </div>
      </div>
    </div>

<!--    안전·보건 관리계획-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 안전·보건 관리계획</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업 참여자 수</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputC_1 }}</p>
        <ml-input
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_1"
          class="w-full flex-1"
        />&nbsp;명
      </div>
      <div class="print-container col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">작업 중 유해·위험 사항</div>
        <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputC_2 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_2"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
      <div class="print-container col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">안전·보건 관리 대책</div>
        <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputC_3 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputC_3"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
    </div>

    <!--    안전·보건 관리계획 이행여부 확인 점검-->
<!--    <vs-row class="mt-4">-->
<!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
<!--        <h5><i class="dot"></i> 안전·보건 관리계획 이행여부 확인 점검</h5>-->
<!--      </vs-col>-->
<!--    </vs-row>-->
<!--    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">-->
<!--      <div class="print-container col-span-12 flex items-start mt-4">-->
<!--        <div class="label-text mr-4 mt-2">작업 중 유해·위험 사항</div>-->
<!--        <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputC_4 }}</p>-->
<!--        <ml-textarea-->
<!--          :readonly="board.readonly"-->
<!--          v-else-->
<!--          v-model="form.inputC_4"-->
<!--          class="flex-1 w-full"-->
<!--          rows="5"-->
<!--        />-->
<!--      </div>-->
<!--      <div class="print-container col-span-12 flex items-start mt-4">-->
<!--        <div class="label-text mr-4 mt-2">안전·보건 관리 대책</div>-->
<!--        <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputC_5 }}</p>-->
<!--        <ml-textarea-->
<!--          :readonly="board.readonly"-->
<!--          v-else-->
<!--          v-model="form.inputC_5"-->
<!--          class="flex-1 w-full"-->
<!--          rows="5"-->
<!--        />-->
<!--      </div>-->
<!--    </div>-->

    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 안전·보건 관리계획 이행여부 확인 점검</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">점검일자</div>
        <p v-if="isPrint" class="print-input flex-1">
          {{ form.inputD_1 }}
        </p>
        <date-selector
          v-else
          :readonly="board.readonly"
          class="w-full flex-1"
          v-model="form.inputD_1"
        />
      </div>
      <div class="col-span-8 flex items-center"/>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">확인자(업무담당자)</div>
        <p v-if="isPrint" class="print-input flex-1">{{ form.inputD_2 }}</p>
        <ml-input
          :readonly="board.readonly"
          v-else
          v-model="form.inputD_2"
          class="w-full flex-1"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div>서명</div>
        <sign-field v-if="!isPrint"  v-model="form.inputD_3" class="w-full flex-1 p-1"/>
        <div v-else class="w-full flex-1 p-1">
          <img v-if="form.inputD_3" :src="form.inputD_3" width="100%" alt="Signature" class="signatureImg" />
          <div v-else class="signatureImg"></div>
        </div>
      </div>
      <div class="print-container col-span-12 flex items-start mt-4">
        <div class="label-text mr-4">개선(시정) 사항</div>
        <vs-checkbox class="mr-5"
                     v-model="form.inputD_4"
                     color="secondary"
                     :disabled="board.readonly">해당없음</vs-checkbox>
      </div>
      <div v-if="!form.inputD_4" class="col-span-4 items-center">
        <div class="w-full mr-4 mb-2 label-text">조치 확인일자</div>
        <p v-if="isPrint" class="print-input flex-1">
          {{ form.inputD_5 }}
        </p>
        <date-selector
          v-else
          :readonly="board.readonly"
          class="w-full flex-1"
          v-model="form.inputD_5"
        />
      </div>
      <div v-if="!form.inputD_4" class="print-container col-span-12 items-start mt-4">
        <div class="w-full mr-4 mb-2 label-text">조치확인 사항</div>
        <p v-if="isPrint" class="print-textarea flex-1">{{ form.inputD_6 }}</p>
        <ml-textarea
          :readonly="board.readonly"
          v-else
          v-model="form.inputD_6"
          class="flex-1 w-full"
          rows="5"
        />
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TrainingDisasterClassSelector from '@/components/selector/TrainingDisasterClassSelector'
import TableInspect from '@/components/TableInspect'
import TableInspectDivision from '@/components/TableInspectDivision'
import TableDuration from '../../../../components/TableDuration'
import DisasterClassSelector from '@/components/selector/DisasterClassSelector'
import SignField from "@/components/SignField.vue";

export default {
  components: {
    SignField,
    DisasterClassSelector,
    TableDuration,
    TableInspectDivision,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    TrainingDisasterClassSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler (value) {
        if (value) {
          const keys = Object.keys(this.form)
          for (const key of keys) {
            if (value[key]) {
              this.form[key] = value[key]
            }
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        value.summary = {
          안전보건점검_사업장명: [],
          안전보건점검_점검표: []
        }

        value.summary['안전보건점검_사업장명'].push({
          [this.form.stdInfo.field_name]: 1
        })

        value.summary['안전보건점검_점검표'].push({
          ['자율안전점검 컨설팅']: 1
        })
        this.$emit('input', value)
      },
    },
  },
  methods: {

  },
  data () {
    return {
      form: {
        stdInfo: {},

        inputB_1: '',
        inputB_2: '',
        inputB_3: '',
        inputB_4: '',
        inputB_4_1: '',

        inputC_1: '',
        inputC_2: '',
        inputC_3: '',
        inputC_4: '',
        inputC_5: '',

        inputD_1: '',
        inputD_2: '',
        inputD_3: '',
        inputD_4: false,
        inputD_5: '',
        inputD_6: '',

        fileList: [],
      },
    }
  },

  created() {
    if (this.value) {
      const keys = Object.keys(this.form)
      for (const key of keys) {
        if (this.value[key]) {
          this.form[key] = this.value[key]
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
